import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';
import Icon from '~/components/Icon';

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  border: solid 1px ${colors.grey10};
  background-color: ${colors.grey5};
  border-radius: 0.25rem;
`;

const MaterialPlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0.625rem;
  padding: 0 0.25rem;
  color: ${colors.grey40};
  font-size: 0.75rem;
  background-color: ${colors.white};
  border-radius: 0.3125rem;
  transform: translateY(-50%);
  pointer-events: none;
`;

const Image = styled.img`
  max-height: 10rem;
  max-width: 100%;
`;

const Placeholder = styled.div`
  color: ${colors.grey10};
  font-size: 8rem;
`;

function ReadImage({ label, value }) {
  return (
    <Wrapper>
      <Container>
        {value ? (
          <Image src={value} alt={label} />
        ) : (
          <Placeholder>
            <Icon icon="image" />
          </Placeholder>
        )}
        {!!label && <MaterialPlaceholder>{label}</MaterialPlaceholder>}
      </Container>
    </Wrapper>
  );
}

export default ReadImage;
